module.exports = __webpack_public_path__ + "img/logo.cefae70d.png";